import React from 'react';
import PropTypes from 'prop-types';

import Button, {ButtonSizes} from './ButtonNew';
import {useAnalytics} from '../hooks';

import LandingHero from '../../assets/images/landing_hero.jpg';

export const LandingIntro = (props) => {
  const {tracker} = useAnalytics();

  const onCtaClickHandler = () => {
    tracker.landingClickViewCourses();
  };

  return (
    <div className="container px-8 py-12 bg-white">
      <div className="flex flex-col md:flex-row justify-center items-center md:justify-start">
        <div className={props.leftWidthClass}>
          <div className="flex justify-center md:justify-start">{props.leftHeroComponent}</div>
          <h1 className="mt-2 md:mt-6 text-3xl md:text-6xl text-center md:text-left text-gray-900 font-bold tracking-tight leading-none">
            {props.lead}
          </h1>
          <h3 className="mt-4 mb-6 max-w-xl text-lg md:text-xl text-center md:text-left text-gray-600 font-medium leading-tight tracking-tight">
            {props.heading}
          </h3>
          {props.ctaText && (
            <div className="mt-4 flex justify-center md:justify-start">
              <Button
                size={ButtonSizes.LARGE}
                onClick={onCtaClickHandler}
                href={props.ctaUrl}
                className="w-full sm:w-auto"
              >
                {props.ctaText}
              </Button>
            </div>
          )}
        </div>
        {props.rightHeroComponent || (
          <div className="hidden lg:block w-full mb-4 ml-8">
            <img
              src={LandingHero.src}
              className="pointer-events-none"
              alt="Tech companies and candidates"
            />
          </div>
        )}
      </div>
    </div>
  );
};

LandingIntro.propTypes = {
  lead: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string.isRequired,
  rightHeroComponent: PropTypes.node,
  leftHeroComponent: PropTypes.node,
  leftWidthClass: PropTypes.string.isRequired,
};

LandingIntro.defaultProps = {
  rightHeroComponent: undefined,
  leftHeroComponent: () => {},
};

export default LandingIntro;
